import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/exame`;

export default class ExameService{
	static async consultar() {
		return axios.get(URL_BASE + "/consultar");
	}
}



// WEBPACK FOOTER //
// ./src/service/ExameService.js